<template>
  <v-layout
    v-if="amount.total"
    class="pa-4"
    column
  >
    <v-layout justify-space-between row>
      <v-flex class="header ml-5">
        <h1 class="title -tongue">
          Olá, <strong>{{ username }}</strong>.
          Você tem {{ amount.total }} auto{{ amount.total !== 1 ? 's' : '' }}
          de infração:
        </h1>
      </v-flex>
    </v-layout>

    <v-layout row justify-start class="mt-4">
      <v-layout align-center>
        <filter-cards
          v-if="amount.total"
          @changeActive="toggleActive"
          :cards="cards"
        />
      </v-layout>
    </v-layout>
  </v-layout>
</template>

<script>
import FilterCards from '@/components/application/list/FilterCards';
import colors from 'vuetify/es5/util/colors';
import { isEqual, findIndex } from 'lodash';

export default {
  name: 'InfractionsHeader',
  components: {
    FilterCards,
  },
  data() {
    return {
      username: JSON.parse(localStorage.getItem('user')).name,
    };
  },
  props: {
    activeStatus: {
      type: String,
      default: '',
    },
    infraction_notices: {
      type: Array,
      default: () => [],
    },
    amount: {
      type: Object,
    }
  },
  methods: {
    toggleActive(card) {
      const newActiveItemIndex = findIndex(this.cards, ['title', card.title]);
      this.cards[newActiveItemIndex].active = true;
      this.$emit('activeStatusChanged', card.status);
    },
  },
  computed: {
    cards() {
      return [
        {
          title: 'TODOS',
          status: '',
          amount: this.amount.total,
          borderColor: colors.grey.base,
          backgroundColor: colors.grey.lighten2,
          active: isEqual(this.activeStatus, ''),
        },
        {
          title: 'A ENVIAR',
          status: 'waiting_to_be_sent',
          amount: this.amount.waiting_to_be_sent,
          showToUser: this.isAdmin,
          borderColor: colors.red.base,
          backgroundColor: colors.red.lighten5,
          active: isEqual(this.activeStatus, 'waiting_to_be_sent'),
        },
        {
          title: 'NOVO',
          status: 'new_application',
          amount: this.amount.new,
          showToAdmin: !this.isAdmin,
          borderColor: colors.blue.base,
          backgroundColor: colors.blue.lighten5,
          active: isEqual(this.activeStatus, 'new_application'),
        },
        {
          title: 'PENDENTE',
          status: 'pending',
          amount: this.amount.pending,
          borderColor: colors.amber.base,
          backgroundColor: colors.amber.lighten5,
          active: isEqual(this.activeStatus, 'pending'),
        },
        {
          title: 'PAGO',
          status: 'done',
          amount: this.amount.done,
          borderColor: colors.green.base,
          backgroundColor: colors.green.lighten5,
          active: isEqual(this.activeStatus, 'done'),
        },
        {
          title: 'VENCIDO',
          status: 'expired',
          amount: this.amount.expired,
          borderColor: colors.red.base,
          backgroundColor: colors.red.lighten5,
          active: isEqual(this.activeStatus, 'expired'),
        },
      ];
    },
    isAdmin(){
      return this.$route.meta.userType === 'Admin'
    },
  },
};
</script>
